module.exports = __webpack_public_path__ + "static/media/service3.5d94c25c.png";